import {MuEvent, MuNamedWidgets, MuWidget} from "mu-widget/lib/MuWidget";
import {ActivityVariant} from "../../types";
import {colorTheme} from "../../ColorTheme";
import { InfiniteSelector } from "../InfiniteSelector";
import {appTL} from "../../gen/tl";

export class UiActivityVariantSelector extends MuWidget
{
    // @ts-ignore
    muNamedWidget: MuNamedWidgets<{
        // items:TreeView,
        selector: InfiniteSelector
    }>;
    beforeIndex() {
        this.muRegisterEvent('select');
        this.container.classList.add('activity-variant-selector-item');
        this.muAppendContent(`
            <div mu="selector:InfiniteSelector"></div>
        `);
    }

    selector_select(ev, item) {
        this.muDispatchEvent('select', item);
    }

    bindVariants(activityId: number) {
        // this.muNamedWidget.items.render(variant);
        this.muNamedWidget.selector.setDataLoader(
            async (
                filters: { fulltext?: string|null, letter?: string|null, categoryId?: number|null },
                loadCategories: boolean,
                limitFrom: number,
                limitCount: number
            ) => {
                const data = await appTL.findActivityVariant(
                    activityId,
                    // @ts-ignore
                    filters,
                    loadCategories,
                    limitFrom,
                    limitCount,
                );
                for (const item of data.items) {
                    if (item.group) item.id += '#' + item.group;
                }

                return data;
            }
        )
    }

    items_itemRedered(ev: MuEvent, widget: UiActivityVariantSelectorItem) {
        widget.afterRendered();
    }

    selectItem(item: ActivityVariant) {
        item = {
            ...item,
            id: parseInt(item.id),
        }
        this.muDispatchEvent('select', item);
    }
}

export class UiActivityVariantSelectorItem extends MuWidget {

    // @ts-ignore
    item: ActivityVariant;
    isGroup = false;

    beforeIndex() {
        this.container.classList.add('activity-variant-selector-item');
        this.muAppendContent(`
            <div class="activity-variant-selector-item__name" mu="nameContainer"><span mu="name#name"></span></div>
            <ul class="activity-variant-selector-item__items" mu="children"></ul>
        `);
    }

    protected muAfterBindData(data: any) {
        this.ui.name.classList.add('icon-size--24', 'icon-before--' + (data.icon || 'blank'));
        this.muVisible(false, 'children');
        this.item = data;
        if (data.color) {
            this.container.style.setProperty('--bg-color-light', colorTheme.colorToLightBg(data.color));
            this.container.style.setProperty('--bg-color-dark', colorTheme.colorToDarkBg(data.color));
        }
    }

    afterRendered() {
        this.isGroup = this.ui.children.childElementCount > 0;
        this.ui.name.classList.toggle('activity-variant-selector-item__name--group', this.isGroup);
    }

    nameContainer_click() {
        if (this.isGroup)
            this.muVisible('toggle', 'children');
        else
            (this.muParent.muParent as UiActivityVariantSelector).selectItem(this.item);
    }
}